import { acceptHMRUpdate, defineStore } from 'pinia'
import api from '@api'
import type { BookingLinkCreate, BookingLinksCountsRetrieveParams, BookingLinksListParams, BookingsListParams, BookingsTimelineParams, TimeSlotBookingApprove, TimeSlotBookingChangeGate, TimeSlotBookingCreate, TimeSlotBookingUpdate } from '@apiTypes'

export const useBookingsStore = defineStore('bookings', {
  actions: {
    fetchBookings(query: BookingsListParams) {
      return api.bookings.bookingsList(query)
    },

    fetchBookingAddressGateOptions() {
      return api.bookings.bookingsAddressGateOptionsList()
    },

    fetchTimeline(query: BookingsTimelineParams) {
      return api.bookings.bookingsTimeline(query)
    },

    fetchBookingDetail(id: number) {
      return api.bookings.bookingsRetrieve({ id })
    },

    fetchBookingPreview(id: number) {
      return api.bookings.bookingsPreview({ id })
    },

    fetchAvailableGates(id: number, includeConflicts: boolean) {
      return api.bookings.bookingsAvailableGates({ id, includeConflicts })
    },

    changeBookingGate(id: number, payload: TimeSlotBookingChangeGate) {
      return api.bookings.bookingsChangeGate({ id }, payload)
    },

    rejectBooking(id: number) {
      return api.bookings.bookingsReject({ id })
    },

    cancelBooking(id: number) {
      return api.bookings.bookingsCancel({ id })
    },

    approveBooking(id: number, payload: TimeSlotBookingApprove) {
      return api.bookings.bookingsApprove({ id }, payload)
    },

    createBooking(payload: TimeSlotBookingCreate) {
      return api.bookings.bookingsCreate(payload)
    },

    updateBooking(id: number, payload: TimeSlotBookingUpdate) {
      return api.bookings.bookingsUpdate({ id }, payload)
    },

    fetchBookingLinks(query: BookingLinksListParams) {
      return api.bookingLinks.bookingLinksList(query)
    },

    fetchBookingLinkCounts(query: BookingLinksCountsRetrieveParams) {
      return api.bookingLinks.bookingLinksCountsRetrieve(query)
    },

    createBookingLink(payload: BookingLinkCreate) {
      return api.bookingLinks.bookingLinksCreate(payload)
    },

    resendBookingLink(id: number) {
      return api.bookingLinks.bookingLinksResend({ id })
    },

    revokeBookingLink(id: number) {
      return api.bookingLinks.bookingLinksRevoke({ id })
    },

    deleteBookingLink(id: number) {
      return api.bookingLinks.bookingLinksDestroy({ id })
    },
  },
})

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useBookingsStore, import.meta.hot))
